<template>
  <div id="top">
    <Row>
      <Col span="4" style="text-align:left;">
        <slot name="left"></slot>
      </Col>
      <Col span="16"><slot name="center"></slot></Col>
      <Col span="4" style="text-align:right;">
      <slot name="right"></slot>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  methods: {
    
  }
};
</script>
<style lang="">
#top {
  background: #3d8bd3;
  height: 46px;
  width: 100%;
  padding: 0 10px;
  line-height: 46px;
  color: #fff;
  text-align: center;
}
#top i {
  font-size: 20px;
}
#top p{
  font-size: 16px;
}
#top .active{
  border-bottom: solid 2px #fff;
  font-weight: bold;
  padding-bottom: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/top.vue